module.exports = __webpack_public_path__ + "static/media/bank.85883f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/bank.png
// module id = 169
// module chunks = 0